import { ContentPage } from '../page-factory/content-page';
import { maghMelaPage } from '../pages/page-magh-mela';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Magh Mela 2026 - Sacred Bathing Dates - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Discover the sacred bathing dates of Magh Mela 2026. Learn about the significance of each Snan and plan your spiritual journey with Kumbh Sukrit.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026',
    },
  ];
};

export default function MaghMelaIndexPage() {
  return <ContentPage {...maghMelaPage} />;
}
